import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isNativeShell, isMarketingPath } from "@/lib/runtime";
import { useAuth } from "@/hooks/useAuth";

/**
 * Native-shell route gate.
 *
 * Only active inside packaged apps (Electron / Capacitor). When the user
 * lands on a marketing route (/, /about, /blog, /pricing, etc.) we
 * forward them into the product:
 *   - signed in   → /dashboard
 *   - signed out  → /auth
 *
 * In a normal browser this component does nothing — the marketing site
 * stays fully accessible at https://aicavite.com.
 *
 * Course detail / learn / certificate / admin / instructor routes are
 * NEVER intercepted, so push-notification deep links keep working.
 */
export function NativeShellGate() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!isNativeShell()) return;
    if (loading) return;
    if (!isMarketingPath(location.pathname)) return;

    const target = user ? "/dashboard" : "/auth";
    if (location.pathname !== target) {
      navigate(target, { replace: true });
    }
  }, [location.pathname, user, loading, navigate]);

  return null;
}
